/* jshint esversion: 6 */
import React from 'react';
import SocialPanelModule from 'app/mixins/SocialPanelModule.js';
import { Link } from 'react-router-dom';

class TumblrOptions extends React.Component {
    render() {
        let currentPanel = null,
            constants = this.props.app.config.constants,
            postTitle = (parseInt(this.props.getParamValue('postTitle'), 10)) ? true : false,
            postBody = (parseInt(this.props.getParamValue('postBody'), 10)) ? true : false,
            postUrl = (parseInt(this.props.getParamValue('postUrl'), 10)) ? true : false,
            postImages = (parseInt(this.props.getParamValue('postImages'), 10)) ? true : false,
            prefixSpace = (parseInt(this.props.getParamValue('prefixSpace'), 10)) ? true : false,
            postfixSpace = (parseInt(this.props.getParamValue('postfixSpace'), 10)) ? true : false,
            postStyles = [
                { value: constants.TUMBLR_POST_TEXT, label: 'Text' },
                { value: constants.TUMBLR_POST_LINK, label: 'Link' }
            ],
            visibleSettings = null;

        if (this.props.activePanel !== 'advanced') {
            if (this.props.hasInputOverrides) {
                if (this.props.user.detail.routeViewType === this.props.app.config.constants.ROUTE_VIEW_SIMPLE) {
                    visibleSettings = this.props.generateInputOverrideLink();
                } else {
                    visibleSettings = (
                        <div>
                            {this.props.generateInputOverrideWarning()}
                            {this.props.getPostStyles(postStyles)}
                            {this.props.getPostTitle(postTitle)}
                            {this.props.getPostBody(postBody)}
                            {this.props.getPostUrl(postUrl)}
                            {this.props.getPostPhoto(postImages)}ß
                        </div>
                    )
                }
            } else {
                visibleSettings = (
                    <div>
                        {this.props.getPostStyles(postStyles)}
                        {this.props.getPostTitle(postTitle)}
                        {this.props.getPostBody(postBody)}
                        {this.props.getPostUrl(postUrl)}
                        {this.props.getPostPhoto(postImages)}
                    </div>
                )
            }

            currentPanel = (
                <div>
                    {visibleSettings}
                    {this.props.getPrefixText(prefixSpace)}
                    {this.props.getPostfixText(postfixSpace)}
                    {this.props.getActiveToggle()}
                    {this.props.getDeleteButton()}
                </div>
            );
        }

        return this.props.getPanelOutput(currentPanel);
    }

};

export default SocialPanelModule(TumblrOptions);
